import locales from "../data/locales.json"

export const DEFAULT_LOCALE = "en-US"
export const DEFAULT_LANGUAGE = "en"
export const LOCALES = locales
